import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ActionsDropdownForGroup } from '../../components/base/ActionsDropdown';
import CountComponent from '../../components/base/CountComponent';
import ListFilterComponent from '../../components/base/ListFilterComponent';
import { ImageTextButton } from '../../components/base/CustomImageButton';
import { Tabs, Tab } from 'react-bootstrap';
import filterImage from '../../assets/images/32filter.svg';
import { withResizeDetector } from 'react-resize-detector';

const TabContainer = ({
  width,
  maxTabWidth = 0,
  tabs,
  activeTab,
  listContent,
  onSelect,
}) => {
  let tabShown = true;
  if (tabShown && maxTabWidth > 0 && width - 440 < maxTabWidth) {
    tabShown = false;
  }
  return (
    <Tabs
      activeKey={activeTab}
      onSelect={onSelect}
      className={`campaign-list-tab-container ${
        tabShown ? '' : 'hide-tab-bar'
      }`}
    >
      {tabs.map((config, index) => {
        return (
          <Tab
            key={`${index}-${config.key}`}
            eventKey={config.key}
            title={config.name}
          >
            {config.key === activeTab ? (
              listContent
            ) : (
              <div>
                {config.key} - {activeTab}
              </div>
            )}
          </Tab>
        );
      })}
    </Tabs>
  );
};
const TabContainerWithSize = withResizeDetector(TabContainer);

function BaseTabListContainer({
  maxTabWidth = 0,
  hideTab,
  hideSearch = false,
  groupActions,
  tabs,
  pageInfo,
  totalCount,
  listContent,
  defaultTabKey,
  searchPlaceholder,
  // showDeletePrompt,
  filter = {},
}) {
  const history = useHistory();
  const location = useLocation();

  const queryString = require('query-string');
  const [activeTab, setActiveTab] = useState(
    queryString.parse(location.search)['type'] || 'all',
  );
  // const [searchKey, setSearchKey] = useState();
  const [showFilter, setShowFilter] = useState(false);

  const getFilterCount = () => {
    let filterCount = 0;
    const querySearch = queryString.parse(location.search);
    Object.entries(querySearch).map(([key, value]) => {
      if (Object.keys(querySearch).includes(querySearch[key])) {
        return;
      }
      if (!['page', 'rank', 'search', 'sort'].includes(key) && value) {
        if (
          (key === 'type' && value.toLowerCase().indexOf('all') < 0) ||
          key !== 'type'
        )
          filterCount += 1;
      }
    });

    return filterCount;
  };

  useEffect(() => {
    setActiveTab(queryString.parse(location.search)['type'] || 'all');
    // setSearchKey(queryString.parse(location.search)['search']);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const filterCount = getFilterCount();

  useEffect(() => {
    if (defaultTabKey) {
      setActiveTab(defaultTabKey);
    }
  }, [defaultTabKey, tabs]);
  //   useEffect(() => {
  //     setShowPrompt(showDeletePrompt);
  //   }, [showDeletePrompt]);

  return (
    <>
      {showFilter ? (
        <filter.componment backAction={() => setShowFilter(false)} />
      ) : null}
      <div className="all-list-scrollable-area" key={''}>
        <div id="tabindex" className="all-list-component-action-header">
          <div className="all-list-component-action-header-div">
            {groupActions?.length > 0 ? (
              <ActionsDropdownForGroup actions={groupActions} />
            ) : null}
            <CountComponent
              start={pageInfo?.startCursor}
              end={pageInfo?.endCursor}
              total={totalCount}
            />
          </div>
        </div>

        {/* <EarningruleListData tabs={tabs} /> */}
        <div className="all-list-table-content">
          {hideTab ? (
            <div>
              <nav className="campaign-list-tab-container nav nav-tabs" />
              {listContent}
            </div>
          ) : (
            <TabContainerWithSize
              tabs={tabs}
              activeTab={activeTab}
              maxTabWidth={maxTabWidth}
              listContent={listContent}
              onSelect={(key) => {
                history.push({
                  pathname: location.pathname,
                  hash: location.hash,
                  search: queryString.stringify({
                    search: '',
                    page: 1,
                    type: key,
                    rank: true,
                  }),
                });
                setActiveTab(key);
              }}
            />
          )}
        </div>

        {filter.hasFilter ? (
          <div className="all-list-filter-container">
            <ImageTextButton
              action={() => setShowFilter(!showFilter)}
              image={filterImage}
              title={'Filter'}
            />
            {filterCount > 0 ? (
              <label className="filter-badge-icon">{filterCount}</label>
            ) : null}
          </div>
        ) : null}

        <div className="all-list-search-container">
          {hideSearch ? (
            <div></div>
          ) : (
            <ListFilterComponent
              // defaultValue={searchKey}
              searchPlaceholder={searchPlaceholder}
              onSearch={(key) => {
                history.push({
                  pathname: location.pathname,
                  hash: location.hash,
                  search: queryString.stringify({
                    ...queryString.parse(location.search),
                    ...{ search: key, page: 1 },
                  }),
                });
              }}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default BaseTabListContainer;
